<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <el-form :model="articleForm" ref="articleForm" :rules="articleFormRules" label-width="120px" size="medium"
        style="padding-right: 10%;" class="demo-form-inline">
        <el-row>
          <el-col :span="12">
            <el-form-item label="排序" prop="sort">
              <el-input-number clearable v-model="articleForm.sort" :min="1"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标题">
              <el-input v-model="articleForm.title"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="渠道">
              <el-select v-model="selectedChannels" @change="show(channels)" multiple placeholder="请选择渠道">
                <el-option v-for="channel in channels" :key="channel.channelId" :label="channel.channelName"
                  :value="channel.channelId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="跳转链接">
              <el-input v-model="articleForm.qrUrl"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="推广开始时间">
              <el-date-picker v-model="articleForm.startTime" clearable format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="推广结束时间">
              <el-date-picker v-model="articleForm.endTime" type="date" clearable format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss" align="right" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="缩略图" prop="thumbnail">
          <el-upload :class="{ hide: hideThumbnail }" :limit="thumbnailLimit" :file-list="thumbnailFileList"
            :action="this.env.env.uploadUrl" list-type="picture-card" :on-success="uploadThumbnailSuccess"
            :on-preview="uploadThumbnailPreviewHandler" :on-remove="uploadThumbnailRemoveHandler">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="内容">
          <article-edit v-on:listenToChildEvent="showMsgFromEdit" :parent-content="articleForm.content"></article-edit>
        </el-form-item>
        <el-form-item style="padding: 0; margin: 0;">
          <el-button
            @click="linkTo('/popularize/article/list')">&nbsp;&nbsp;&nbsp;取&nbsp;&nbsp;消&nbsp;&nbsp;&nbsp;</el-button>
          <el-button type="primary" :loading='loading'
            @click="submitArticleForm('articleForm')">&nbsp;&nbsp;&nbsp;确&nbsp;&nbsp;定&nbsp;&nbsp;&nbsp;</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import articleEdit from "../../../components/plugins/edit/articleEdit";
import { reqCode, dialogAction } from '@/common/const';
export default {
  name: "articleAdd",
  components: {
    articleEdit,
  },
  data() {
    return {
      selectedChannels: [],
      articleForm: {
        sort: 1,
        content: `<br/> `
      },
      articleFormRules: {},
      channels: [],
      createTime: [],
      hideThumbnail: false,
      dialogAction: '',
      articleSelectVal: -1,
      thumbnailLimit: 1,
      thumbnailFileList: [],
      loading: false
    }
  },
  created() {
    this.dialogAction = this.$route.params.action;
    if (dialogAction.EDIT == this.dialogAction) {
      this.articleForm = JSON.parse(this.$route.params.data);
    }
    this.getChannels();
  },
  mounted() {
  },
  methods: {
    uploadThumbnailSuccess(resp, file, list) {
      this.hideThumbnail = list.length >= this.thumbnailLimit;
      if (reqCode.SUCCESS == resp.code) {
        this.articleForm.thumbnail = resp.data;
      } else {
        this.$message({
          message: '上传缩略图失败：' + resp.message,
          type: 'error'
        });
      }
    },
    uploadThumbnailPreviewHandler(file) {
      this.articleForm.thumbnail = file.url;
    },
    uploadThumbnailRemoveHandler(file, list) {
      this.hideThumbnail = list.length >= this.thumbnailLimit;
    },

    articleSelectChange(val) {
      this.articleSelectVal = val;
      this.articleForm.status = val;
    },
    linkTo(url) {
      this.$router.push({ path: url });
    },
    show(data) {
      console.log(data);
      console.log(this.selectedChannels);
    },
    showMsgFromEdit(data) {
      this.articleForm.content = data;
    },
    getChannels() {
      this.$http.post('/api/channel-service/channel/logged/all', {}, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        this.channels = data.resultList;
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      });
    },
    addArticle(formName, reqParam) {
      this.loading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post(this.env.apiUrl + '/api/popularize/article/add', reqParam, {
            headers: {
              accessToken: sessionStorage.getItem('accessToken')
            }
          }).then(resp => {
            this.loading = false
            let data = resp.data;
            console.log(data.code)
            if ('success' === data.code) {
              this.$message({
                message: '新增文章成功',
                type: 'success'
              });
              this.linkTo('/popularize/article/list');
            } else {
              this.$alert('' + data.message, '错误提示', {
                confirmButtonText: '确定',
              });
            }
          }).catch(e => {
            this.$alert('' + e, '错误提示', {
              confirmButtonText: '确定',
            });
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    submitArticleForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let reqParam = {
            title: this.articleForm.title,
            content: this.articleForm.content,
            channelIds: this.selectedChannels,
            startTime: this.articleForm.startTime,
            endTime: this.articleForm.endTime,
            thumbnail: this.articleForm.thumbnail,
            qrUrl: this.articleForm.qrUrl,
            sort: this.articleForm.sort,
          };
          this.addArticle(formName, reqParam);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$nextTick(() => {
        this.createTime = [];
        this.articleForm = {
          sort: 1,
          content: `<br/>`
        };
        this.selectedChannels = [];
        this.$refs[formName].resetFields();
      })
    },
  },
  destroyed() {
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/popularize/article/articleAdd.vue